var _circle, _circle2, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalsCrusher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3F234B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.75,
    stroke: "url(#paint0_linear_83_56453)",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_56453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8991 12.5598L16.5686 12.2509L15.2456 9.17891C15.153 8.9638 14.848 8.9638 14.7554 9.17891L13.4325 12.2509L10.102 12.5598C9.86877 12.5814 9.77454 12.8715 9.95047 13.0261L12.4633 15.2336L11.7279 18.4965C11.6764 18.725 11.9232 18.9042 12.1246 18.7847L15.0005 17.077L17.8765 18.7847C18.0779 18.9043 18.3246 18.725 18.2731 18.4965L17.5377 15.2336L20.0506 13.0261C20.2265 12.8715 20.1323 12.5814 19.8991 12.5598Z",
    fill: "url(#paint1_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.596 9.06764C11.7658 9.30347 12.245 10.3162 12.519 10.9065C12.5621 10.9993 12.4457 11.0831 12.3714 11.0128C11.8985 10.5657 11.0901 9.78999 10.9203 9.55414C10.7859 9.36754 10.8283 9.10736 11.0149 8.97301C11.2015 8.83867 11.4617 8.88105 11.596 9.06764Z",
    fill: "url(#paint2_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4049 9.06764C18.2352 9.30347 17.7559 10.3162 17.482 10.9065C17.4389 10.9993 17.5553 11.0831 17.6296 11.0128C18.1025 10.5657 18.9109 9.78996 19.0807 9.55414C19.215 9.36754 19.1727 9.10736 18.9861 8.97301C18.7995 8.83867 18.5393 8.88105 18.4049 9.06764Z",
    fill: "url(#paint3_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0882 15.9836C20.8119 15.8935 19.7014 15.7446 19.0558 15.663C18.9544 15.6501 18.9099 15.7865 18.9994 15.836C19.569 16.1506 20.5537 16.6851 20.83 16.7752C21.0486 16.8465 21.2836 16.7271 21.3549 16.5085C21.4262 16.2899 21.3068 16.0549 21.0882 15.9836Z",
    fill: "url(#paint4_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91234 15.9836C9.1886 15.8935 10.2991 15.7446 10.9447 15.663C11.0461 15.6501 11.0906 15.7865 11.0011 15.836C10.4315 16.1506 9.44679 16.6851 9.17053 16.7752C8.95193 16.8465 8.71693 16.7271 8.64563 16.5085C8.57434 16.2899 8.69374 16.0549 8.91234 15.9836Z",
    fill: "url(#paint5_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5957 20.6811C14.5957 20.3906 14.7985 19.2886 14.9211 18.6496C14.9403 18.5491 15.0838 18.5491 15.103 18.6496C15.2255 19.2886 15.4284 20.3906 15.4284 20.6811C15.4284 20.9111 15.242 21.0975 15.012 21.0975C14.7821 21.0975 14.5957 20.9111 14.5957 20.6811Z",
    fill: "url(#paint6_linear_83_56453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7267 10.296L15.2456 9.17891C15.153 8.9638 14.848 8.9638 14.7554 9.17891L13.4324 12.2509L10.102 12.5598C9.86877 12.5814 9.77454 12.8715 9.95047 13.0261L12.4633 15.2336L11.7279 18.4965C11.6764 18.725 11.9232 18.9042 12.1246 18.7847L12.5073 18.5574C13.1348 14.4953 14.899 11.5135 15.7267 10.296Z",
    fill: "url(#paint7_linear_83_56453)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4133 10.1348L19.1269 10.8984L18.3633 11.1848L19.1269 11.4711L19.4133 12.2348L19.6996 11.4711L20.4633 11.1848L19.6996 10.8984L19.4133 10.1348Z",
    fill: "#FDF3F3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_83_56453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4039 16.8789L11.005 17.9425L9.94141 18.3414L11.005 18.7403L11.4039 19.8039L11.8028 18.7403L12.8664 18.3414L11.8028 17.9425L11.4039 16.8789Z",
    fill: "#FDF3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_83_56453",
    x: 8.44141,
    y: 15.3789,
    width: 5.92505,
    height: 5.92578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_83_56453"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_56453",
    x1: 15,
    y1: 1.5,
    x2: 15,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_56453",
    x1: 15.0005,
    y1: 9.01758,
    x2: 15.0005,
    y2: 18.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_83_56453",
    x1: 11.6851,
    y1: 8.89453,
    x2: 11.6851,
    y2: 11.0389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83_56453",
    x1: 18.3159,
    y1: 8.89453,
    x2: 18.3159,
    y2: 11.0389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_56453",
    x1: 20.1633,
    y1: 15.6621,
    x2: 20.1633,
    y2: 16.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_83_56453",
    x1: 9.83717,
    y1: 15.6621,
    x2: 9.83717,
    y2: 16.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_83_56453",
    x1: 15.012,
    y1: 18.5742,
    x2: 15.012,
    y2: 21.0975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_83_56453",
    x1: 12.793,
    y1: 9.01758,
    x2: 12.793,
    y2: 18.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BF6A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_56453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.75,
    height: 12.75,
    fill: "white",
    transform: "translate(8.625 8.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsCrusher);
export default __webpack_public_path__ + "static/media/goals-crusher.f29eb756a0f96ffa5b8a8dc6eee3d217.svg";
export { ForwardRef as ReactComponent };